// SlicePlugin definition for the checkbox slice (PRD-F2 §TR3, §T12).
//
// Migrated to the discriminated-union CapabilityDescriptor form (PRD-X §TR3).
// Declares 7 capability descriptors including the new 'plain-edit' marker for
// the label inline-editor. Diverges from rectangle by omitting 'resize' (the
// checkbox is fixed-size, click-to-place) and 'border-style' (it draws its
// own stroke). Adds 'text-content' for the label and 'plain-edit' for the
// dedicated PlainEditController. isAnchorTarget always returns true per ND2.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  TEXT_CONTENT_VIEW,
  PLAIN_EDIT,
  ANCHOR_TARGET_VIEW,
  BG_COLOR_VIEW,
  BG_COLOR_EDIT,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
  ROTATION_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { CheckboxObject } from './checkbox.interface.js';
import { createCheckboxDefaults } from './checkbox-defaults.factory.js';
import { createNode, updateNode } from './checkbox.renderer.js';

const CHECKBOX_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'text-content', view: TEXT_CONTENT_VIEW },
  { capability: 'plain-edit', edit: PLAIN_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'background-color', view: BG_COLOR_VIEW, edit: BG_COLOR_EDIT },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
  { capability: 'rotation', edit: ROTATION_EDIT },
];

export const checkboxSlice: SlicePlugin<CheckboxObject> = {
  type: 'checkbox',
  role: 'primary',
  capabilities: CHECKBOX_CAPABILITIES,
  display: {
    iconUrl: 'fa-check-square',
    label: 'Checkbox',
  },
  createDefaults: createCheckboxDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
};
